import React from 'react';
import { useSelector } from 'react-redux'

import OutlineStock from 'Component/stock/outline';
import OutlineEtf from 'Component/etf/outline';

const Outline = () => {

  const { tickerDetail } = useSelector((state) => state.stock);

	return (
    <>
      { tickerDetail && tickerDetail.outline && tickerDetail.STK_TYP === 1 &&
        <OutlineStock data={tickerDetail} />
      }
      { tickerDetail && tickerDetail.outline && tickerDetail.STK_TYP === 2 && 
        <OutlineEtf data={tickerDetail} />
      }
    </>
  );
}

export default Outline;
